<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import StepProgress from "@/components/widgets/StepProgress";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import ModalImagePreview from "./ModalImagePreview.vue";
import ModalSoalPreview from "./ModalSoalPreview.vue";

export default {
  page: {
    title: "Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    StepProgress,
    ModalImagePreview,
    ModalSoalPreview,
  },
  computed: {
    tipeNormalized() {
      return this.previewDataSoal?.tipe?.toLowerCase() || "";
    },

    isObjectiveType() {
      return ["pilihan ganda", "benar salah"].includes(this.tipeNormalized);
    },

    isMatchingType() {
      return this.tipeNormalized === "menjodohkan";
    },

    isEssayType() {
      return ["text", "essay", "essai"].includes(this.tipeNormalized);
    },
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "", name: "-" },
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Tipe", name: "-" },
      { width: "auto", label: "Studi Kasus", name: "-" },
      { width: "auto", label: "Soal Gambar", name: "pertanyaan" },
      { width: "auto", label: "Pertanyaan", name: "-" },
      { width: "auto", label: "Jumlah Jawaban", name: "-" },
      { width: "auto", label: "Status", name: "-" },
      { width: "270px", label: "Aksi", name: "-" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      isWrite: 1,
      isRead: 1,
      title: "Soal",
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      columns: columns,
      sortKey: "kompetensi_idkompetensi",
      sortOrders: sortOrders,

      currentTablePage: "",
      tableFilter: {
        status: 1,
        search: "",
        page: 1,
        per_page: 10,
        type_soal: "pg",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      modalImport: false,
      importFile: null,
      showModalImagePreview: false,
      showModalSoalPreview: false,
      previewUrl: "",
      previewDataSoal: null,
      listSoalDitandai: [],
    };
  },
  mounted() {
    this.getKompetensi();
    this.getData();
  },
  methods: {
    async getKompetensi() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: `Application/json`,
        },
      }).then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
        console.log({ kompetensi: this.kompetensi });
      }
    },
    async getData() {
      this.isLoading = true;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi +
          "/soal",
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalImagePreview = true;
    },
    async previewSoal(id) {
      try {
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "verifikasi/kompetensi-level/" +
            this.idKompetensi +
            "/soal/" +
            id,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        this.previewDataSoal = res.data.data;
        // this.previewDataSoal.tipe = "menjodohkan";
        this.showModalSoalPreview = true;
      } catch (err) {
        console.error(err);
      }
    },

    getImageUrl(path) {
      return this.link + path;
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },

    toPage(page) {
      this.tableFilter.page = page;
      this.getData();
    },

    async deleteData(row) {
      const result = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Data soal akan dihapus permanen.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sedang memproses data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/${row.idverif_soal}`,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Status data berhasil hapus.",
            timer: 1500,
            showConfirmButton: false,
          });
          this.getData();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error.response?.data?.meta?.message ||
              "Terjadi kesalahan saat menghapus data.",
          });
        }
      }
    },

    async deleteMultiple(restore = false) {
      if (!this.listSoalDitandai.length) return;

      const transaction = restore
        ? "memulihkan"
        : this.tableFilter.status == 1
        ? "menonaktifkan"
        : "menghapus permanen";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${transaction} ${this.listSoalDitandai.length} data soal yang ditandai?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        const method =
          restore || this.tableFilter.status == 1 ? "put" : "delete";
        const status = restore ? 1 : 0;

        try {
          await axios({
            method: method,
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal`,
            data: {
              ids: this.listSoalDitandai,
              status: status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async deleteAll() {
      const action = "menghapus";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${action} SEMUA data soal pada level kompetensi ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        try {
          await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/all`,
            data: {
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Semua data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async changeStatus(row) {
      const action = row.active_flag == 1 ? "nonaktifkan" : "aktifkan";
      const result = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Data soal akan di-${action}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sedang memproses data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/${row.idverif_soal}/status`,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Status data berhasil diubah.",
            timer: 1500,
            showConfirmButton: false,
          });
          this.getData();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error.response?.data?.meta?.message ||
              "Terjadi kesalahan saat mengubah status.",
          });
        }
      }
    },

    async changeStatusMultiple() {
      if (!this.listSoalDitandai.length) return;

      const transaction =
        this.tableFilter.status == 1 ? "menonaktifkan" : "memulihkan";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${transaction} ${this.listSoalDitandai.length} data soal yang ditandai?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        const method = "put";

        try {
          await axios({
            method: method,
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/status`,
            data: {
              ids: this.listSoalDitandai,
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async changeStatusAll() {
      const action =
        this.tableFilter.status == 1 ? "menonaktifkan" : "menghapus";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${action} SEMUA data soal pada level kompetensi ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        try {
          await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/status/all`,
            data: {
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Semua data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Soal</div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.nama_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'all-kompetensi-level' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i> Kembali
                  </router-link>
                  <button
                    class="btn btn-success btn-sm"
                    @click="modalImport = true"
                    v-if="isWrite == 1"
                  >
                    <i class="fa fa-file-excel me-1"></i>
                    Import Soal Kompetensi
                  </button>
                  <router-link
                    class="btn btn-primary btn-sm"
                    :to="{ name: 'tambah-verif-soal' }"
                    v-if="isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i>
                    Tambah
                  </router-link>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <StepProgress currentStatus="DRAFT" />
              </div>
              <div class="col-12">
                <hr />
                <div class="row mb-2">
                  <div class="form-group col-md-2">
                    <label for="statusTable">Status</label>
                    <select
                      class="form-select"
                      id="statusTable"
                      v-model="tableFilter.status"
                      @change="
                        getData();
                        listSoalDitandai = [];
                      "
                    >
                      <option value="1">ENABLE</option>
                      <option value="0">DISABLE</option>
                    </select>
                  </div>
                </div>
                <hr />
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mb-1">
              <button
                class="btn btn-warning btn-sm"
                :disabled="!listSoalDitandai.length"
                @click="changeStatusMultiple()"
                v-if="isWrite == 1"
              >
                <span v-if="tableFilter.status == 1">
                  <i class="fa fa-trash me-1"></i>
                  Disable Soal Ditandai
                </span>
                <span v-else>
                  <i class="fa fa-recycle me-1"></i> Restore Soal Ditandai
                </span>
              </button>
              <button
                class="btn btn-warning btn-sm"
                @click="changeStatusAll()"
                v-if="isWrite == 1"
              >
                <span v-if="tableFilter.status == 1">
                  <i class="fa fa-trash me-1"></i>
                  Disable Semua Soal
                </span>
                <span v-else>
                  <i class="fa fa-recycle me-1"></i>
                  Restore Semua Soal Ditandai
                </span>
              </button>
              <button
                class="btn btn-danger btn-sm"
                :disabled="!listSoalDitandai.length"
                @click="deleteMultiple(false)"
                v-if="tableFilter.status == 0 && isWrite == 1"
              >
                <i class="fa fa-trash me-1"></i>
                Hapus Soal Ditandai
              </button>
              <button
                class="btn btn-danger btn-sm"
                @click="deleteAll()"
                v-if="tableFilter.status == 0 && isWrite == 1"
              >
                <i class="fa fa-trash me-1"></i>
                Hapus Semua Soal
              </button>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex align-items-end">
                <table>
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="getData()"
                />
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in table_data"
                    :key="key_data"
                  >
                    <td class="text-center">
                      <input
                        type="checkbox"
                        class="largerCheckbox"
                        :value="row_data.idverif_soal"
                        v-model="listSoalDitandai"
                      />
                    </td>
                    <td>{{ key_data + pagination.from }}</td>
                    <td>{{ row_data.tipe }}</td>
                    <td>{{ row_data.objektif?.kategori?.kategori ?? '-' }}</td>
                    <td>
                      <div
                        class="container-image"
                        v-if="row_data.pertanyaan_gambar"
                      >
                        <img
                          v-if="row_data.pertanyaan_gambar"
                          :src="link + row_data.pertanyaan_gambar"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="
                              previewImage(link + row_data.pertanyaan_gambar)
                            "
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>{{ row_data.pertanyaan }}</td>
                    <td class="text-center">{{ row_data.jawaban_count }}</td>
                    <td class="text-center">
                      <span
                        class="badge font-size-12"
                        :class="{
                          'bg-warning': ['DRAFT', 'KOREKSI'].includes(
                            row_data.status_soal,
                          ),
                          'bg-info text-dark':
                            row_data.status_soal === 'PENDING',
                          'bg-danger': row_data.status_soal === 'REVISI',
                          'bg-success': row_data.status_soal === 'APPROVED',
                        }"
                      >
                        {{ row_data.status_soal }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex gap-1 justify-content-center">
                        <button
                          class="btn btn-info btn-sm"
                          @click="previewSoal(row_data.idverif_soal)"
                          v-if="row_data.active_flag"
                        >
                          <i class="fa fa-search me-1"></i> Preview
                        </button>
                        <router-link
                          class="btn btn-primary btn-sm"
                          :to="{
                            name: 'edit-verif-soal',
                            params: {
                              id: this.idKompetensi,
                              idSoal: row_data.idverif_soal,
                            },
                          }"
                          v-if="row_data.active_flag"
                        >
                          <i class="fa fa-edit me-1"></i> Setup
                        </router-link>
                        <button
                          class="btn btn-danger btn-sm"
                          v-if="row_data.active_flag"
                          @click="changeStatus(row_data)"
                        >
                          <i class="fa fa-trash me-1"></i> Disable
                        </button>
                        <button
                          class="btn btn-warning btn-sm"
                          v-if="!row_data.active_flag"
                          @click="changeStatus(row_data)"
                        >
                          <i class="fa fa-recycle me-1"></i> Enable
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          v-if="!row_data.active_flag"
                          @click="deleteData(row_data)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>

            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <ModalImagePreview v-model="showModalImagePreview" :url="previewUrl" />

  <ModalSoalPreview
    v-model="showModalSoalPreview"
    :data="previewDataSoal"
    :link="link"
  />
</template>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}

/* optional: kalau gambar gede banget (diagram) */
@media (min-width: 1200px) {
  .soal-image {
    max-height: 500px;
  }
}
</style>
